import React from 'react';
import '../../Styles/interests.css'
import Interest from './Subcomponent/Interest'

const Interests = () => (
        <div className="container" >
            <h1 className="o-title-int">HOW I CREATE IMPACT</h1>
            <div className=" row interests o-int">
                <Interest
                    icon="fa-cogs"
                    title="GTM & Automation"
                    description="Designing systems that capture leads, automate workflows, and support business growth."
                ></Interest>
                <Interest
                    icon="fa-chart-line"
                    title="Conversion-Focused Development"
                    description="Building pages and features optimized for engagement, performance, and conversion."
                ></Interest>
                <Interest
                    icon="fa-plug"
                    title="Marketing Integrations"
                    description="Connecting analytics, CRMs, forms, and email systems into seamless workflows."
                ></Interest>
                <Interest
                    icon="fa-laptop-code"
                    title="Frontend Systems Development"
                    description="Building scalable, high-performance applications with React, Next.js, and TypeScript."
                ></Interest>
                <Interest
                    icon="fa-chart-pie"
                    title="Analytics & Optimization"
                    description="Using data and tracking to improve decisions, user journeys, and performance."
                ></Interest>
                <Interest
                    icon="fa-vial"
                    title="Testing & Reliability"
                    description="Ensuring product quality with automated testing and maintainable code practices."
                ></Interest>
                <Interest
                    icon="fa-object-group"
                    title="UX Implementation"
                    description="Turning ideas and designs into polished, responsive, user-centered experiences."
                ></Interest>
                <Interest
                    icon="fa-users"
                    title="Async Collaboration & Delivery"
                    description="Working effectively in remote teams with clear communication and iterative delivery."
                ></Interest>

            </div>


        </div>
);
export default Interests;
